import Colors from '@config/colors';
import useColors from '../../../hooks/useColors';
import Loader from '@components/Loader';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Divider, Image, Row } from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import Text from '@components/Text';
import VideoPlayer from '@components/videoPlayer';
import printer from '@assets/images/printer.png';
import Button from '@components/Button';
import DateTimeComponent from '@config/util/DateAndTimeParser';
import { convertToPdf } from '@config/util/pdfConverter.js';
import { useEffect, useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { ReportAction } from '@store/actions';
import { twMerge } from 'tailwind-merge';
import GenerateReport from './GenerateReport';
import { REPORT_TYPES } from './helper';
import videoThumbnail from '../../../assets/images/videoThumbnail.jpg';
import { SecurityReport } from '@components';

const ViewReport = () => {
    const { colorPrimary } = useColors();
    const [downloading, setDownloading] = useState(false);
    const [resetDrawer, setResetDrawer] = useState(false);
    const { user } = useSelector(
        (state) => state?.AppReducer,
    );
    const printRef = useRef(null);
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const searchParams = new URLSearchParams(window.location.search);
    const reportType = searchParams.get('reportType') || REPORT_TYPES.daily;

    const prefillValues = useMemo(() => {
        const p = new URLSearchParams(window.location.search);
        const propertyId = p.getAll('propertyId[]');
        const incidentTypeId = p.getAll('incidentTypeId[]');
        const startDate = p.get('startDate');
        const endDate = p.get('endDate');
        const level = p.get('level');
        const assignee = p.get('assignee');
        return {
            dates: {
                startDate: startDate || dayjs().format('YYYY-MM-DD'),
                endDate: endDate || dayjs().format('YYYY-MM-DD'),
            },
            propertyId: propertyId.length > 0 ? propertyId.map(Number) : undefined,
            incidentTypeId: incidentTypeId.length > 0 ? incidentTypeId.map(Number) : undefined,
            status: p.get('status') || undefined,
            level: level !== null && level !== '' ? Number(level) : undefined,
            assignee: assignee ? Number(assignee) : undefined,
        };
    }, [window.location.search]);

    const downloadReportPdf = async () => {
        setDownloading(true);
        const printEl = printRef.current;
        if (printEl) {
            printEl.style.setProperty('position', 'static', 'important');
            printEl.style.setProperty('left', 'auto', 'important');
            printEl.style.setProperty('top', 'auto', 'important');
            printEl.style.setProperty('opacity', '1', 'important');
            printEl.style.setProperty('height', 'auto', 'important');
            printEl.style.setProperty('overflow', 'visible', 'important');
            printEl.style.setProperty('padding', '1.2cm', 'important');
            printEl.style.setProperty('box-sizing', 'border-box', 'important');
            printEl.style.setProperty('width', '100%', 'important');
        }
        await convertToPdf(printRef);
        if (printEl) {
            printEl.style.removeProperty('position');
            printEl.style.removeProperty('left');
            printEl.style.removeProperty('top');
            printEl.style.removeProperty('opacity');
            printEl.style.removeProperty('height');
            printEl.style.removeProperty('overflow');
            printEl.style.removeProperty('padding');
            printEl.style.removeProperty('box-sizing');
            printEl.style.removeProperty('width');
        }
        setDownloading(false);
    };

    const { loader, reportsData } = useSelector(
        (state) => state?.ReportReducer,
    );

    console.log({ reportsData }, "Burhuerebrhb");

    const hasData =
        reportsData &&
        Object.keys(reportsData).length > 0 &&
        Array.isArray(reportsData?.data) &&
        reportsData?.data?.length > 0;

    useEffect(() => {
        dispatch(ReportAction.GenerateReport(window.location.search));
    }, [`${window.location.search}`]);

    return (
        <>
            <Row gutter={[16, 20]} className="mb-10 mt-2 no-print">
                <Col span={24}>
                    <h3 className="text-xl font-bold">Reporting / Analytics</h3>
                </Col>
                <Col span={24}>
                    <div className="flex items-center justify-between">
                        <div>
                            <IoArrowBack
                                className="cursor-pointer inline "
                                size={18}
                                onClick={() =>
                                    navigate('/security-issues/report')
                                }
                            />
                            <span className="ml-2">Back</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <Button.Basic
                                className="h-10 border-none px-4 text-white border-transparent"
                                style={{ backgroundColor: colorPrimary }}
                                text={'Reset Filters'}
                                size="small"
                                onClick={() => setResetDrawer(true)}
                            />
                            {hasData && (
                                <Button.Basic
                                    className="h-10 border-none px-4 text-white border-transparent"
                                    style={{ backgroundColor: Colors.Black }}
                                    text={'Download PDF'}
                                    size="small"
                                    onClick={downloadReportPdf}
                                />
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
            <div className="no-print">
                {loader ? (
                    <Loader.Circular
                        spinning={loader}
                        size={40}
                        color={colorPrimary}
                        containerStyle={{
                            width: '100%',
                            height: '60vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    />
                ) : hasData ? (
                    reportsData?.data?.map((reportItem) => (
                        <>
                            <Row
                                className="rounded-lg py-6 px-4 mb-4"
                                style={{ background: Colors.White }}
                            >
                                <Col
                                    lg={24}
                                    xl={24}
                                    className="flex items-center justify-between w-full flex-wrap"
                                >
                                    <div className="flex gap-1 flex-wrap">
                                        <Text.Basic
                                            fontSize="18"
                                            fontWeight="700"
                                            text={`Issue# ${reportItem?.id ? reportItem?.id : '-'}`}
                                        />
                                        <Text.Basic
                                            fontSize="18"
                                            color={Colors.Error}
                                            fontWeight="700"
                                            text={`(Level ${reportItem?.level ? reportItem?.level : '-'})`}
                                        />
                                    </div>
                                    <img
                                        className={twMerge(
                                            'cursor-pointer',
                                            downloading && 'invisible',
                                        )}
                                        onClick={() => window.print()}
                                        src={printer}
                                        height={35}
                                        width={35}
                                    />
                                </Col>
                                <Col span={24}>
                                    <Text.Basic
                                        fontSize="14"
                                        fontWeight="600"
                                        text={'Property Details'}
                                    />
                                </Col>
                                <Divider />

                                <Row className="w-full" gutter={[16, 16]}>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Location Name'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.property?.name
                                                ? reportItem?.property?.name
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Property Address'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.address
                                                ? `${reportItem?.address?.streetNumber}, ${reportItem?.address?.streetName}, ${reportItem?.address?.city} ${reportItem?.address?.zip}`
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Location'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.address
                                                ? `${reportItem?.address?.streetNumber}, ${reportItem?.address?.streetName}, ${reportItem?.address?.city} ${reportItem?.address?.zip}`
                                                : '-'}
                                        </p>
                                    </Col>
                                </Row>
                                <Divider />

                                <Row className="w-full" gutter={[16, 16]}>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Reported Address'}
                                        />

                                        <p className="text-xs break-all">
                                            {reportItem?.address
                                                ? `${reportItem?.address?.streetNumber}, ${reportItem?.address?.streetName}, ${reportItem?.address?.city} ${reportItem?.address?.zip}`
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Actual Address/Unit'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.unit
                                                ? reportItem?.unit
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={8} md={8} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Floor'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.floor
                                                ? reportItem?.floor
                                                : '-'}
                                        </p>
                                    </Col>
                                </Row>
                            </Row>

                            <Row
                                className="rounded-lg py-6 px-4 mb-4"
                                style={{ background: Colors.White }}
                            >
                                <Col
                                    lg={24}
                                    xl={24}
                                    className="flex items-center justify-between"
                                >
                                    <div className="flex gap-1">
                                        <Text.Basic
                                            fontSize="18"
                                            fontWeight="700"
                                            text={`Created Details`}
                                        />
                                    </div>
                                </Col>

                                <Divider />

                                <Row className="w-full" gutter={[16, 16]}>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Approx Occurance Time'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.createdDate
                                                ? DateTimeComponent(
                                                    reportItem?.createdDate,
                                                    'time',
                                                )
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Create Date'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.createdDate
                                                ? DateTimeComponent(
                                                    reportItem?.createdDate,
                                                    'date',
                                                )
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Created By'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.reportedBy?.firstName
                                                ? reportItem?.reportedBy
                                                    ?.firstName +
                                                ' ' +
                                                reportItem?.reportedBy
                                                    ?.lastName
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={6} md={6} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Assigned By'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.assignedBy?.first_name
                                                ? reportItem?.assignedBy
                                                    ?.first_name +
                                                ' ' +
                                                reportItem?.assignedBy
                                                    ?.last_name
                                                : '-'}
                                        </p>
                                    </Col>
                                </Row>
                                <Divider />
                            </Row>

                            <Row
                                className="rounded-lg py-6 px-4 mb-4"
                                style={{ background: Colors.White }}
                            >
                                <Col
                                    lg={24}
                                    xl={24}
                                    className="flex items-center justify-between"
                                >
                                    <div className="flex gap-1">
                                        <Text.Basic
                                            fontSize="18"
                                            fontWeight="700"
                                            text={`Assigned Details`}
                                        />
                                    </div>
                                </Col>

                                <Divider />

                                <Row className="w-full" gutter={[16, 16]}>
                                    <Col lg={5} md={5} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Acknowledged By'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.assignedTo?.firstName
                                                ? reportItem?.assignedTo
                                                    ?.firstName +
                                                ' ' +
                                                reportItem?.assignedTo
                                                    ?.lastName
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={5} md={5} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Acknowledged Date'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.acknowledgedDate
                                                ? reportItem?.acknowledgedDate
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={5} md={5} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Arrived User'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.assignedTo?.firstName
                                                ? reportItem?.assignedTo
                                                    ?.firstName +
                                                ' ' +
                                                reportItem?.assignedTo
                                                    ?.lastName
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={5} md={5} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Arrived Date'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.assignedDate
                                                ? DateTimeComponent(
                                                    reportItem?.assignedDate,
                                                    'date',
                                                )
                                                : '-'}
                                        </p>
                                    </Col>
                                    <Col lg={4} md={4} sm={24} xs={24}>
                                        <Text.Label
                                            style={{ color: Colors.LabelColor }}
                                            text={'Status'}
                                        />
                                        <p className="text-xs break-all">
                                            {reportItem?.assignedTo?.status
                                                ? reportItem?.assignedTo?.status
                                                : '-'}
                                        </p>
                                    </Col>
                                </Row>
                                <Divider />
                            </Row>

                            <Row className="mb-4">
                                <Text.Basic
                                    fontSize="14"
                                    fontWeight="500"
                                    text={`Photos`}
                                />
                                <Row className="w-full flex gap-2">
                                    {reportItem?.incidentAttachments?.length > 0
                                        ? reportItem?.incidentAttachments?.map(
                                            (attachment, index) => {
                                                if (
                                                    attachment?.format ==
                                                    'png' ||
                                                    attachment?.format ==
                                                    'jpg' ||
                                                    attachment?.format ==
                                                    'jpeg'
                                                ) {
                                                    return (
                                                        <Col
                                                            key={index}
                                                            lg={3}
                                                            xl={3}
                                                            md={6}
                                                            sm={6}
                                                            xs={12}
                                                            className=""
                                                        >
                                                            <Image
                                                                src={
                                                                    attachment?.url
                                                                }
                                                                height="100%"
                                                                width="100%"
                                                            />
                                                        </Col>
                                                    );
                                                } else if (
                                                    attachment?.format ==
                                                    'mp4'
                                                ) {
                                                    return (
                                                        <Col
                                                            key={index}
                                                            lg={3}
                                                            xl={3}
                                                            md={6}
                                                            sm={6}
                                                            xs={12}
                                                        >
                                                            <VideoPlayer
                                                                posterSrc={
                                                                    videoThumbnail
                                                                }
                                                                videoSrc={
                                                                    attachment?.url
                                                                }
                                                            />
                                                        </Col>
                                                    );
                                                }
                                            },
                                        )
                                        : ''}
                                </Row>
                            </Row>
                        </>
                    ))
                ) : (
                    <div className="h-20 text-center px-4">No Data</div>
                )}
            </div>

            <div ref={printRef} className="print-only">
                {hasData && reportsData?.data?.map((reportItem) => (
                    <div key={reportItem?.id} style={{ pageBreakAfter: 'always', marginBottom: '20px' }}>
                        <SecurityReport reportData={reportItem} user={user} />
                    </div>
                ))}
            </div>

            <GenerateReport
                openDrawer={resetDrawer}
                onCloseDrawer={() => setResetDrawer(false)}
                reportType={reportType}
                prefillValues={prefillValues}
            />
        </>
    );
};

export default ViewReport;
